<div class="grid sm:grid-cols-4 gap-6 w-full max-w-200" data-tour-id="numerowanie-dokumentow">
    <div class="sm:col-span-2">
        <div class="flex-auto cursor-pointer">
            <div class="leading-6 font-semibold">Numerowanie dokumentów</div>
            <div class="text-md text-secondary">Automatycznie ustawiaj numery kolejnych dokumentów</div>
        </div>
    </div>
    <div class="sm:col-span-2">
        <mat-slide-toggle color="primary" [formControl]="documentNumbering">
            {{documentNumbering.value ? "Włączone" : "Wyłączone"}}
        </mat-slide-toggle>
    </div>
</div>